export const ALL_COUNTRIES = [
  { id: 'afghanistan', label: 'Afghanistan' },
  { id: 'albania', label: 'Albania' },
  { id: 'algeria', label: 'Algeria' },
  { id: 'andorra', label: 'Andorra' },
  { id: 'angola', label: 'Angola' },
  { id: 'antigua-and-barbuda', label: 'Antigua and Barbuda' },
  { id: 'argentina', label: 'Argentina' },
  { id: 'armenia', label: 'Armenia' },
  { id: 'australia', label: 'Australia' },
  { id: 'austria', label: 'Austria' },
  { id: 'azerbaijan', label: 'Azerbaijan' },
  { id: 'bahamas', label: 'Bahamas' },
  { id: 'bahrain', label: 'Bahrain' },
  { id: 'bangladesh', label: 'Bangladesh' },
  { id: 'barbados', label: 'Barbados' },
  { id: 'belarus', label: 'Belarus' },
  { id: 'belgium', label: 'Belgium' },
  { id: 'belize', label: 'Belize' },
  { id: 'benin', label: 'Benin' },
  { id: 'bhutan', label: 'Bhutan' },
  { id: 'bolivia', label: 'Bolivia' },
  { id: 'bosnia-and-herzegovina', label: 'Bosnia and Herzegovina' },
  { id: 'botswana', label: 'Botswana' },
  { id: 'brazil', label: 'Brazil' },
  { id: 'brunei', label: 'Brunei' },
  { id: 'bulgaria', label: 'Bulgaria' },
  { id: 'burkina-faso', label: 'Burkina Faso' },
  { id: 'burundi', label: 'Burundi' },
  { id: 'cambodia', label: 'Cambodia' },
  { id: 'cameroon', label: 'Cameroon' },
  { id: 'canada', label: 'Canada' },
  { id: 'cape-verde', label: 'Cape Verde' },
  { id: 'central-african-republic', label: 'Central African Republic' },
  { id: 'chad', label: 'Chad' },
  { id: 'chile', label: 'Chile' },
  { id: 'china', label: 'China' },
  { id: 'colombia', label: 'Colombia' },
  { id: 'comoros', label: 'Comoros' },
  { id: 'congo', label: 'Congo' },
  { id: 'costa-rica', label: 'Costa Rica' },
  { id: 'croatia', label: 'Croatia' },
  { id: 'cuba', label: 'Cuba' },
  { id: 'cyprus', label: 'Cyprus' },
  { id: 'czech-republic', label: 'Czech Republic' },
  { id: 'democratic-republic-of-congo', label: 'Democratic Republic of Congo' },
  { id: 'denmark', label: 'Denmark' },
  { id: 'djibouti', label: 'Djibouti' },
  { id: 'dominica', label: 'Dominica' },
  { id: 'dominican-republic', label: 'Dominican Republic' },
  { id: 'east-timor', label: 'East Timor' },
  { id: 'ecuador', label: 'Ecuador' },
  { id: 'egypt', label: 'Egypt' },
  { id: 'el-salvador', label: 'El Salvador' },
  { id: 'equatorial-guinea', label: 'Equatorial Guinea' },
  { id: 'eritrea', label: 'Eritrea' },
  { id: 'estonia', label: 'Estonia' },
  { id: 'eswatini', label: 'Eswatini' },
  { id: 'ethiopia', label: 'Ethiopia' },
  { id: 'fiji', label: 'Fiji' },
  { id: 'finland', label: 'Finland' },
  { id: 'france', label: 'France' },
  { id: 'gabon', label: 'Gabon' },
  { id: 'gambia', label: 'Gambia' },
  { id: 'georgia', label: 'Georgia' },
  { id: 'germany', label: 'Germany' },
  { id: 'ghana', label: 'Ghana' },
  { id: 'greece', label: 'Greece' },
  { id: 'grenada', label: 'Grenada' },
  { id: 'guatemala', label: 'Guatemala' },
  { id: 'guinea', label: 'Guinea' },
  { id: 'guinea-bissau', label: 'Guinea-Bissau' },
  { id: 'guyana', label: 'Guyana' },
  { id: 'haiti', label: 'Haiti' },
  { id: 'honduras', label: 'Honduras' },
  { id: 'hungary', label: 'Hungary' },
  { id: 'iceland', label: 'Iceland' },
  { id: 'india', label: 'India' },
  { id: 'indonesia', label: 'Indonesia' },
  { id: 'iran', label: 'Iran' },
  { id: 'iraq', label: 'Iraq' },
  { id: 'ireland', label: 'Ireland' },
  { id: 'israel', label: 'Israel' },
  { id: 'italy', label: 'Italy' },
  { id: 'ivory-coast', label: 'Ivory Coast' },
  { id: 'jamaica', label: 'Jamaica' },
  { id: 'japan', label: 'Japan' },
  { id: 'jordan', label: 'Jordan' },
  { id: 'kazakhstan', label: 'Kazakhstan' },
  { id: 'kenya', label: 'Kenya' },
  { id: 'kiribati', label: 'Kiribati' },
  { id: 'kuwait', label: 'Kuwait' },
  { id: 'kyrgyzstan', label: 'Kyrgyzstan' },
  { id: 'laos', label: 'Laos' },
  { id: 'latvia', label: 'Latvia' },
  { id: 'lebanon', label: 'Lebanon' },
  { id: 'lesotho', label: 'Lesotho' },
  { id: 'liberia', label: 'Liberia' },
  { id: 'libya', label: 'Libya' },
  { id: 'liechtenstein', label: 'Liechtenstein' },
  { id: 'lithuania', label: 'Lithuania' },
  { id: 'luxembourg', label: 'Luxembourg' },
  { id: 'madagascar', label: 'Madagascar' },
  { id: 'malawi', label: 'Malawi' },
  { id: 'malaysia', label: 'Malaysia' },
  { id: 'maldives', label: 'Maldives' },
  { id: 'mali', label: 'Mali' },
  { id: 'malta', label: 'Malta' },
  { id: 'marshall-islands', label: 'Marshall Islands' },
  { id: 'mauritania', label: 'Mauritania' },
  { id: 'mauritius', label: 'Mauritius' },
  { id: 'mexico', label: 'Mexico' },
  { id: 'micronesia', label: 'Micronesia' },
  { id: 'moldova', label: 'Moldova' },
  { id: 'monaco', label: 'Monaco' },
  { id: 'mongolia', label: 'Mongolia' },
  { id: 'montenegro', label: 'Montenegro' },
  { id: 'morocco', label: 'Morocco' },
  { id: 'mozambique', label: 'Mozambique' },
  { id: 'myanmar', label: 'Myanmar' },
  { id: 'namibia', label: 'Namibia' },
  { id: 'nauru', label: 'Nauru' },
  { id: 'nepal', label: 'Nepal' },
  { id: 'netherlands', label: 'Netherlands' },
  { id: 'new-zealand', label: 'New Zealand' },
  { id: 'nicaragua', label: 'Nicaragua' },
  { id: 'niger', label: 'Niger' },
  { id: 'nigeria', label: 'Nigeria' },
  { id: 'north-korea', label: 'North Korea' },
  { id: 'north-macedonia', label: 'North Macedonia' },
  { id: 'norway', label: 'Norway' },
  { id: 'oman', label: 'Oman' },
  { id: 'pakistan', label: 'Pakistan' },
  { id: 'palau', label: 'Palau' },
  { id: 'panama', label: 'Panama' },
  { id: 'papua-new-guinea', label: 'Papua New Guinea' },
  { id: 'paraguay', label: 'Paraguay' },
  { id: 'peru', label: 'Peru' },
  { id: 'philippines', label: 'Philippines' },
  { id: 'poland', label: 'Poland' },
  { id: 'portugal', label: 'Portugal' },
  { id: 'qatar', label: 'Qatar' },
  { id: 'romania', label: 'Romania' },
  { id: 'russia', label: 'Russia' },
  { id: 'rwanda', label: 'Rwanda' },
  { id: 'saint-kitts-and-nevis', label: 'Saint Kitts and Nevis' },
  { id: 'saint-lucia', label: 'Saint Lucia' },
  { id: 'saint-vincent-and-grenadines', label: 'Saint Vincent and Grenadines' },
  { id: 'samoa', label: 'Samoa' },
  { id: 'san-marino', label: 'San Marino' },
  { id: 'sao-tome-and-principe', label: 'São Tomé and Príncipe' },
  { id: 'saudi-arabia', label: 'Saudi Arabia' },
  { id: 'senegal', label: 'Senegal' },
  { id: 'serbia', label: 'Serbia' },
  { id: 'seychelles', label: 'Seychelles' },
  { id: 'sierra-leone', label: 'Sierra Leone' },
  { id: 'singapore', label: 'Singapore' },
  { id: 'slovakia', label: 'Slovakia' },
  { id: 'slovenia', label: 'Slovenia' },
  { id: 'solomon-islands', label: 'Solomon Islands' },
  { id: 'somalia', label: 'Somalia' },
  { id: 'south-africa', label: 'South Africa' },
  { id: 'south-korea', label: 'South Korea' },
  { id: 'south-sudan', label: 'South Sudan' },
  { id: 'spain', label: 'Spain' },
  { id: 'sri-lanka', label: 'Sri Lanka' },
  { id: 'sudan', label: 'Sudan' },
  { id: 'suriname', label: 'Suriname' },
  { id: 'sweden', label: 'Sweden' },
  { id: 'switzerland', label: 'Switzerland' },
  { id: 'syria', label: 'Syria' },
  { id: 'taiwan', label: 'Taiwan' },
  { id: 'tajikistan', label: 'Tajikistan' },
  { id: 'tanzania', label: 'Tanzania' },
  { id: 'thailand', label: 'Thailand' },
  { id: 'togo', label: 'Togo' },
  { id: 'tonga', label: 'Tonga' },
  { id: 'trinidad-and-tobago', label: 'Trinidad and Tobago' },
  { id: 'tunisia', label: 'Tunisia' },
  { id: 'turkey', label: 'Turkey' },
  { id: 'turkmenistan', label: 'Turkmenistan' },
  { id: 'tuvalu', label: 'Tuvalu' },
  { id: 'uganda', label: 'Uganda' },
  { id: 'ukraine', label: 'Ukraine' },
  { id: 'united-arab-emirates', label: 'United Arab Emirates' },
  { id: 'united-kingdom', label: 'United Kingdom' },
  { id: 'united-states', label: 'United States' },
  { id: 'uruguay', label: 'Uruguay' },
  { id: 'uzbekistan', label: 'Uzbekistan' },
  { id: 'vanuatu', label: 'Vanuatu' },
  { id: 'vatican-city', label: 'Vatican City' },
  { id: 'venezuela', label: 'Venezuela' },
  { id: 'vietnam', label: 'Vietnam' },
  { id: 'yemen', label: 'Yemen' },
  { id: 'zambia', label: 'Zambia' },
  { id: 'zimbabwe', label: 'Zimbabwe' }
];

// Keep the existing AFRICAN_COUNTRIES for backward compatibility
export const AFRICAN_COUNTRIES = ALL_COUNTRIES.filter(country => 
  ['algeria', 'angola', 'benin', 'botswana', 'burkina-faso', 'burundi', 'cameroon', 'cape-verde', 
   'central-african-republic', 'chad', 'comoros', 'congo', 'democratic-republic-of-congo', 'djibouti', 
   'egypt', 'equatorial-guinea', 'eritrea', 'eswatini', 'ethiopia', 'gabon', 'gambia', 'ghana', 
   'guinea', 'guinea-bissau', 'ivory-coast', 'kenya', 'lesotho', 'liberia', 'libya', 'madagascar', 
   'malawi', 'mali', 'mauritania', 'mauritius', 'morocco', 'mozambique', 'namibia', 'niger', 'nigeria', 
   'rwanda', 'sao-tome-and-principe', 'senegal', 'seychelles', 'sierra-leone', 'somalia', 'south-africa', 
   'south-sudan', 'sudan', 'tanzania', 'togo', 'tunisia', 'uganda', 'zambia', 'zimbabwe'].includes(country.id)
);
